import { ErrorPage as CommonErrorPage, type ErrorPageProps } from '@monorepo/common';

function ErrorPage(props: ErrorPageProps) {
  return <CommonErrorPage {...props} />;
}

export default ErrorPage;
